const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedSportsbook: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const sportsbooklists = (state = initialState, action) => {
	switch (action.type) {
		case 'SPORTSBOOKLIST_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SPORTSBOOKLIST_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'SPORTSBOOKLIST_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'SPORTSBOOKLIST_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'SPORTSBOOKLIST_GET_CURRENT':
			return {
				...state,
				selectedSportsbook: action.selectedSportsbook,
			}
		case 'SPORTSBOOKLIST_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default sportsbooklists
